import React from 'react';
import { useNameStep } from './useNameStep';
import { AuthNameStepView } from './AuthNameStepView';

type AuthNameStepProps = {
    loading?: boolean;
    defaultName?: string;
    onNameSubmit: (name: string) => void;
    onAlreadyHaveAccount: () => void;
    error?: string | null;
    dismissError?: () => void;
};

export const AuthNameStep: React.FC<AuthNameStepProps> = ({
    loading,
    defaultName,
    onNameSubmit,
    onAlreadyHaveAccount,
    error,
    dismissError,
}) => {
    const { register, errors, onSubmit } = useNameStep(onNameSubmit, defaultName);
    return (
        <AuthNameStepView
            register={register}
            errors={errors}
            onSubmit={onSubmit}
            loading={loading}
            defaultName={defaultName}
            onAlreadyHaveAccount={onAlreadyHaveAccount}
            error={error}
            dismissError={dismissError}
        />
    );
};
